<template>
  <div class="feedback-reason">
    <div class="feedback-reason__header">
      <div class="feedback-reason__icon">
        <img :src="ListIcon" alt="List" />
      </div>
      <h4 class="feedback-reason__title">Flervalg</h4>
    </div>
    <p class="feedback-reason__question">
      {{
        isEstimateRequest
          ? "Hvorfor valgte dere estimatet?"
          : "Hvorfor valgte dere tilbudet?"
      }}
    </p>
    <ul class="feedback-reason__list">
      <li
        v-for="(reason, index) in reasons"
        :key="index"
        class="feedback-reason__item"
      >
        <div class="feedback-reason__checkbox">
          <img :src="CheckmarkIcon" alt="Checkmark" />
        </div>
        <span class="feedback-reason__text">{{ reason.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import ListIcon from "@/assets/img/List.svg";
import CheckmarkIcon from "@/assets/img/check-mark.svg";
import { Reason } from "@/custom-types/GeneralTypes";

defineProps<{
  reasons: Reason[];
  isEstimateRequest?: boolean;
}>();
</script>

<style lang="scss" scoped>
.feedback-reason {
  background: #f7f0fa;
  border-radius: 8px;
  padding: 16px;

  &__header {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__icon {
    width: 32px;
    height: 32px;
  }

  &__title {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 600;
  }

  &__question {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
  }

  &__list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 4px;
  }

  &__checkbox {
    width: 24px;
    height: 24px;
  }

  &__text {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
